// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `form {
  padding-bottom: 0px !important;
}

.private-joint-pep-container {
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
  max-height: 90vh;
}
.private-joint-pep-container form {
  padding-bottom: 0px !important;
}

.private-pep-container-wc {
  max-height: 50vh !important;
}

.row__footer-btn {
  margin-top: -135px;
  z-index: 100;
  position: relative;
}

.pep-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}
.pep-mask.active {
  min-height: 150px;
}

@media screen and (max-width: 769px) {
  .row__footer-btn {
    margin-top: 0;
    z-index: 100;
    position: relative;
    margin-left: 5%;
    margin-right: 5%;
  }
}
.personal-information-container {
  font-size: 14px;
  border: 0.5px solid #C9D4DF;
  border-radius: 8px;
  padding: 1.7em;
  margin: 2em 0 2em 0;
  max-height: 13em;
  position: relative;
  overflow: hidden;
  transition: all 0.3s;
}
.personal-information-container p {
  cursor: pointer;
}
.personal-information-container .pep-description {
  color: #44474B;
}
.personal-information-container .fadeout-gradient {
  position: absolute;
  display: flex;
  justify-content: center;
  bottom: 0;
  width: 93%;
  height: 60%;
  background-image: linear-gradient(rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255) 49%);
  transition: background-image 1s;
  color: #44474B;
}
.personal-information-container .fadeout-gradient p {
  align-self: flex-end;
}
.personal-information-container img {
  transition: all 0.5s;
}
.personal-information-container.expanded {
  max-height: 350em;
}
.personal-information-container.expanded .fadeout-gradient {
  background-image: linear-gradient(rgba(255, 255, 255, 0) 70%, #fff 99%);
}
.personal-information-container.expanded .fadeout-gradient img {
  transform: rotate(180deg);
}
.personal-information-container.expanded.removeGradient .fadeout-gradient {
  background-image: none;
}

.slider-container {
  justify-content: space-between;
}
.slider-container label.switch {
  margin-top: 0px;
}

.pep-title {
  font-family: "fb-thin", sans-serif;
  font-size: 16px;
  font-weight: bold;
  color: #44474B;
}

.pep-subtitle {
  font-size: 15px;
  font-weight: bold;
  color: #44474B;
}

.pep-content {
  margin-bottom: 2em;
  border-bottom: 1px solid #C9D4DF;
}

.form-container {
  border-bottom: 1px solid #C9D4DF;
  padding-bottom: 2em;
  margin-bottom: 3em;
}

.pep-container {
  border: 0.5px solid #C9D4DF;
  border-radius: 8px;
  margin: 1em 0 1em;
  padding: 0.7em 1.4em 0.7em 1.4em;
  max-height: 3em;
  overflow: hidden;
  transition: all 0.7s;
}
.pep-container .form-group {
  visibility: hidden;
  opacity: 0;
  transition: all 1s;
}
.pep-container img {
  transition: all 0.5s;
}
.pep-container.expanded {
  max-height: 100em;
  border: 2px solid #38A121;
}
.pep-container.expanded .form-group {
  visibility: visible;
  opacity: 1;
}
.pep-container.expanded .pep-title img {
  transform: rotate(180deg);
}
.pep-container .pep-title {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1em;
}
.pep-container .pep-title p {
  margin-bottom: 0px;
}
.pep-container .pep-subtitle {
  margin: 1em 0 0;
}
.pep-container .pep-menu {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #C9D4DF;
  margin: 1.5em 0;
}
.pep-container .pep-menu img {
  height: 28px;
  margin-left: 0.3em;
  cursor: pointer;
}
.pep-container .pep-save {
  cursor: pointer;
  margin: 1em 0 1em;
  display: flex;
  justify-content: flex-end;
}
.pep-container .pep-save p {
  margin: 0 0.8em 0;
}

.wc-container .wc-container-in .personal-information-container {
  text-align: justify;
}
.wc-container .wc-container-in .personal-information-container p {
  margin-bottom: 1.2rem;
}
.wc-container .wc-container-in .personal-information-container .fadeout-gradient {
  width: 93%;
}

@media only screen and (max-width: 500px) {
  .wc-container .wc-container-in form {
    max-height: 80vh;
    overflow: auto;
  }
  .private-joint-pep-container {
    max-height: 100vh;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
